import { render } from "./page14.vue?vue&type=template&id=4c1f8c63&scoped=true"
import script from "./page14.vue?vue&type=script&lang=js"
export * from "./page14.vue?vue&type=script&lang=js"

import "./page14.vue?vue&type=style&index=0&id=4c1f8c63&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1f8c63"]])

export default __exports__